// KPI Period Selectors

import { createSelector } from 'reselect';

// Base selector
const selectKpiPeriodState = (state) => state.kpiPeriod;

// Periods
export const selectPeriods = createSelector(
  [selectKpiPeriodState],
  (kpiPeriod) => kpiPeriod?.periods || []
);

// Selected Period
export const selectSelectedPeriod = createSelector(
  [selectKpiPeriodState],
  (kpiPeriod) => kpiPeriod?.selectedPeriod
);

// Loading State
export const selectLoading = createSelector(
  [selectKpiPeriodState],
  (kpiPeriod) => kpiPeriod?.loading || false
);

// Error State
export const selectError = createSelector(
  [selectKpiPeriodState],
  (kpiPeriod) => kpiPeriod?.error
);

// Filters
export const selectFilters = createSelector(
  [selectKpiPeriodState],
  (kpiPeriod) => kpiPeriod?.filters || {}
);

// Pagination
export const selectPagination = createSelector(
  [selectKpiPeriodState],
  (kpiPeriod) => kpiPeriod?.pagination || {}
);

// Filtered Periods (client-side filtering if needed)
export const selectFilteredPeriods = createSelector(
  [selectPeriods, selectFilters],
  (periods, filters) => {
    let filtered = [...periods];

    // Additional client-side filtering can be added here if needed
    
    return filtered;
  }
);
